import React, {createContext, FC, useContext, useEffect} from "react";
import {useDispatch} from "react-redux";
import {setMiniSidebar} from "../../reducers/sidebar";

export type LayoutContextProps = {
    lang: string,
    theme: string,
    render: {
        rerender: boolean
    },
    children?: React.ReactNode
}

// create context
const LayoutContext = createContext<LayoutContextProps>({
    lang: 'en',
    theme: 'light',
    render: {
        rerender: false
    }
});

const useLayoutContext = () => {
    const context = useContext(LayoutContext);

    if (context === undefined) {
        throw new Error("useApplicationContext was used outside of its Provider");
    }

    return context;
};

const LayoutContextProvider: FC<LayoutContextProps> = props => {
    const {theme, lang, children, render} = props;
    const dispatch = useDispatch();

    useEffect(() => {
        const isMini = localStorage.getItem('is-mini') === 'true';
        if (localStorage.getItem('is-mini') === null) {
            localStorage.setItem('is-mini', isMini ? 'true' : 'false');
        }
        dispatch(setMiniSidebar(isMini));
    }, [dispatch, localStorage]);

    return (
        <LayoutContext.Provider value={{theme, lang, render}}>
            {children}
        </LayoutContext.Provider>
    );
};

export {useLayoutContext, LayoutContextProvider};
